module.exports = __webpack_public_path__ + "media/images/icons/icn_039-4f764f03f6eaf83c4dcf6e8d52fc0f28.svg";